import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const Tab = styled.div`
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  border: 1px solid ${props => props.selected ? '#bbbbbb' : '#dedfe0'};
  border-bottom-width: 0px;
  margin-right: 7px;
  text-align: center;
  background: ${props => props.selected ? 'white' : '#f5fbfc'};
  font-size: 12.5px;
  overflow-wrap: break-word;
  hyphens: auto;
  cursor: pointer;
  transition-property: height, width, flex-basis;
  transition-duration: 0.17s;
  transition-timing-function: ease;
  line-height: 1em;
  flex-basis: ${props => props.selected ? '260px' : '250px'};
  height: ${props => props.selected ? 80 : 60}px;
  &:hover {
    background: white;
  }
  &::after {
    content: '';
    display: ${props => props.selected ? 'block' : 'none'};
    position: absolute;
    bottom: -1px;
    background: white;
    height: 2px;
    width: 100%;
    z-index: 1;
  }
`
const TextContainer = styled.div`
  font-weight: ${props => props.selected ? 600 : 'normal'};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
`

const GenieTab = props => {
  const { text, onClick, selected, id } = props
  return (
    <Tab
      value={name}
      selected={selected}
      onClick={onClick}
      id={id}
    >
      <TextContainer selected={selected}>
        {text}
      </TextContainer>
    </Tab>
  )
}

GenieTab.propTypes = {
  id: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  text: PropTypes.string.isRequired
}

export default GenieTab
